import React, { useEffect, useState, useRef } from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import PathInfo from './PathInfo/PathInfo';
import styles from './PathsInfo.module.scss';

import useMobileDetect from 'use-mobile-detect-hook';

const PathsInfo = ({ paths, customRef, cluster = false }) => {
  const detectMobile = useMobileDetect();
  const isMobile = detectMobile.isMobile();

  const mode = 'out-in';
  const infoRef = useRef(null);

  let [activePath, setActivePath] = useState({});
  useEffect(() => {
    setActivePath(paths[0]);
  }, [paths]);

  return (
    <div
      className={
        isMobile
          ? `${styles.path_info} ${styles.path_info__mobile}`
          : styles.path_info
      }
      ref={customRef}
    >
      <div className={styles.buttons}>
        {paths.map((path) => (
          <button
            key={path.id}
            onClick={() => {
              setActivePath(path);
            }}
            className={path === activePath ? styles.active : null}
          >
            <span>{cluster ? path.categories[0] : path.path_title}</span>
          </button>
        ))}
      </div>
      <SwitchTransition mode={mode}>
        <CSSTransition
          className={'fade'}
          key={activePath?.id}
          nodeRef={infoRef}
          timeout={{ enter: 250, exit: 250 }}
          unmountOnExit
        >
          <div ref={infoRef}>
            {activePath && <PathInfo cluster={cluster} path={activePath} />}
          </div>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};

export default PathsInfo;
